import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
    CnCommissionModelObjectBaseViewComponent
} from '../cn-commission-model-object-base-view/cn-commission-model-object-base-view.component';
import {
    MvsObjectNavigationService
} from 'features/core/shared/navigation/mvs-object-navigation.service';

/**
* Full (left-nav) view of the CommissionModel object component (FR-8).
*
* Left-nav sections: Allgemein / Regeln / Zuordnungen / LogicHooks.
* The Allgemein header shows the status badge (CommissionModelStatus) and the
* approvedBy / approvedAt freigabe-Vermerk.
*/
@Component({
    selector: 'mvs-cn-commission-model-full',
    templateUrl: './cn-commission-model-full.component.html',
    styleUrls: ['./cn-commission-model-full.component.scss'],
    standalone: false
})
export class CnCommissionModelFullComponent extends CnCommissionModelObjectBaseViewComponent
    implements OnInit, OnChanges, OnDestroy {

    constructor(
        protected override activatedRoute: ActivatedRoute,
        protected override navigationService: MvsObjectNavigationService
    ) {
        super(activatedRoute, navigationService);
    }

    /**
    * Left-nav items (G6: action-based, fa-solid icons, German labels with umlauts).
    */
    loadSideBarMenuItems(): void {
        this.navigationItems = [
            {
                label: 'Allgemein',
                action: 'cn.CommissionModel',
                tooltip: 'Allgemein',
                icon: 'fa-solid fa-sliders text-xl',
                toggleable: false,
                default: true
            },
            {
                label: 'Regeln',
                action: 'cn.CommissionRule',
                tooltip: 'Regeln',
                icon: 'fa-solid fa-folder-tree text-xl',
                toggleable: false,
                default: false
            },
            {
                label: 'Zuordnungen',
                action: 'cn.CommissionModelAssignment',
                tooltip: 'Zuordnungen',
                icon: 'fa-solid fa-diagram-project text-xl',
                toggleable: false,
                default: false
            },
            {
                label: 'LogicHooks',
                action: 'cn.CommissionLogicHook',
                tooltip: 'LogicHooks',
                icon: 'fa-solid fa-plug text-xl',
                toggleable: false,
                default: false
            }
        ];
    }

    override ngOnInit(): void {
        this.loadSideBarMenuItems();
        this.initComponent();
        super.ngOnInit();
    }

    /**
    * Re-render the section widgets when the bound objectIdentifier changes.
    * Delegates to the shared base view (G2.3 / G4.6).
    */
    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
